import {
  SignInResponse,
  SignInRequest,
  SignUpRequest,
  SignUpResponse,
  ConfirmEmailResponse,
  GoogleSignInRequest,
  GoogleSignInResponse,
  FacebookSignInRequest,
  FacebookSignInResponse,
  ResetPasswordParams,
} from '../../../models/auth.models';
import { BuilderType, mlkOnQueryStarted, InvalidationTag } from '../../utils';

export const buildSignIn = (builder: BuilderType) =>
  builder.mutation<SignInResponse, SignInRequest>({
    onQueryStarted: mlkOnQueryStarted,
    query: (body) => ({
      url: '/auth/login',
      method: 'POST',
      body,
    }),
    invalidatesTags: () => [
      { type: InvalidationTag.User },
      { type: InvalidationTag.Addresses },
      { type: InvalidationTag.Order },
    ],
  });

export const buildSignUp = (builder: BuilderType) =>
  builder.mutation<SignUpResponse, SignUpRequest>({
    onQueryStarted: mlkOnQueryStarted,
    query: (body) => ({
      url: '/auth/register',
      method: 'POST',
      body,
    }),
    invalidatesTags: () => [
      { type: InvalidationTag.User },
      { type: InvalidationTag.Addresses },
      { type: InvalidationTag.Order },
    ],
  });

export const buildConfirmEmail = (builder: BuilderType) =>
  builder.mutation<ConfirmEmailResponse, string>({
    onQueryStarted: mlkOnQueryStarted,
    query: (code: string) => ({
      url: `/auth/confirmEmail/${code}`,
      method: 'GET',
    }),
  });

export const buildResendConfirmationCode = (builder: BuilderType) =>
  builder.mutation({
    onQueryStarted: mlkOnQueryStarted,
    query: () => ({
      url: `/auth/requestNewEmailConfirmationCode`,
      method: 'GET',
    }),
  });

export const buildGoogleSignIn = (builder: BuilderType) =>
  builder.mutation<GoogleSignInResponse, GoogleSignInRequest>({
    onQueryStarted: mlkOnQueryStarted,
    query: (body) => ({
      url: `/auth/googleSignIn`,
      method: 'POST',
      body,
    }),
    invalidatesTags: () => [
      { type: InvalidationTag.User },
      { type: InvalidationTag.Addresses },
      { type: InvalidationTag.Order },
    ],
  });

export const buildFacebookSignIn = (builder: BuilderType) =>
  builder.mutation<FacebookSignInResponse, FacebookSignInRequest>({
    onQueryStarted: mlkOnQueryStarted,
    query: (body) => ({
      url: `/auth/facebookSignIn`,
      method: 'POST',
      body,
    }),
    invalidatesTags: () => [
      { type: InvalidationTag.User },
      { type: InvalidationTag.Addresses },
      { type: InvalidationTag.Order },
    ],
  });

export const buildRequestResetPassword = (builder: BuilderType) =>
  builder.mutation<{}, string>({
    onQueryStarted: mlkOnQueryStarted,
    query: (email) => ({
      url: `/auth/resetPassword/${email}`,
      method: 'GET',
    }),
  });

export const buildResetPassword = (builder: BuilderType) =>
  builder.mutation<{}, ResetPasswordParams>({
    onQueryStarted: mlkOnQueryStarted,
    query: ({ email, ...body }) => ({
      url: `/auth/resetPassword/${email}`,
      method: 'POST',
      body,
    }),
  });
